var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useAppSelector } from '../../../../store';
import { participantsSelector } from '../../../../store/slices/participantSlice';
const MicStatus = ({ userId }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const render = () => {
        if (participant === null || participant === void 0 ? void 0 : participant.isMuted) {
            return (_jsx("p", { className: "mute", children: _jsx("i", { className: "pnm-mic-mute text-white text-[9px]" }) }));
        }
        else {
            return (_jsx("p", { className: "mute", children: _jsx("i", { className: "pnm-mic-unmute text-white text-[9px]" }) }));
        }
    };
    return (_jsx(_Fragment, { children: (participant === null || participant === void 0 ? void 0 : participant.audioTracks) ? (_jsx("div", { className: "mic-status", children: render() })) : null }));
};
_react_refresh_temp_1 = MicStatus;
$RefreshReg$(_react_refresh_temp_1, "MicStatus");
_react_refresh_temp_2(MicStatus, "mjU79ys6ldxukVUS9mIy8tZDloo=", false, () => [useAppSelector]);
export default MicStatus;
